const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const getHeaderTemplate = ({
  logoSrc = "",
  logoSrcs = [],
} = {}) => {
  const normalizedLogos = Array.isArray(logoSrcs)
    ? logoSrcs.filter(Boolean)
    : logoSrc
      ? [logoSrc]
      : [];
  const headerLogosHtml = normalizedLogos
    .map(
      (src, index) =>
        `<img class="siis-pdf-header__logo" src="${src}" alt="Logo encabezado ${index + 1}" />`
    )
    .join("");

  return `
    <header class="siis-pdf-header">
      <div class="siis-pdf-header__logos">${headerLogosHtml}</div>
    </header>
  `;
};
